import * as yup from "yup";

import {
  Box,
  Button,
  Checkbox,
  Chip,
  FormControlLabel,
  FormHelperText,
  Grid,
  Input,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Typography,
  makeStyles,
} from "@material-ui/core";
import { Controller, useForm } from "react-hook-form";
import { DatePicker, TimePicker } from "./form/DateTimePicker";
import React, { useEffect, useState } from "react";
import {
  activityTagDropdownOptions,
  galleryEventDropdownOptions,
  genreTagDropdownOptions,
} from "../v2_actions/dropdown_options";
import { clone, filter, get, map, size } from "lodash";
import { showError, showSuccess } from "../v2_actions/error";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";

import { GalleryPriceSelector } from "./form/GalleryPriceSelector";
import { GeneralFormErrors } from "./form/GeneralFormErrors";
import { LoaderPercentProgressContainer } from "../views/uploadgallery/loaderComponent";
import LoadingSpinner from "../components/LoadingSpinner";
import { LocationSelector } from "./form/LocationSelector";
import { PhotographUploader } from "./form/PhotographUploader";
import { Separator } from "./layout/Separator";
import { TextField } from "./form/TextField";
import { galleryList } from "../v2_actions/gallery";
import { getUserStoredCountry } from "../v2_actions/auth_country";
import { handleSubmitResult } from "../v2_actions/form";
import { loggedInUserLastName } from "../v2_actions/auth";
import moment from "moment";
import { photographList } from "../v2_actions/photograph";
import { photographerPriceList } from "../v2_actions/photographer_price";
import styles from "./GalleryFormStyles";
import { yupResolver } from "@hookform/resolvers/yup";

const useStyles = makeStyles(styles);

const MenuClass = {
  PaperProps: {
    style: {
      maxHeight: 48 * 4.5 + 8,
      width: 250,
    },
  },
  BlueBtn: {
    background: "#75A9F9",
  },
};

const formSchema = yup.object().shape({
  lat: yup.number().required(),
  lng: yup.number().required(),
});

export const GalleryEditor = ({ match }) => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const { gallery_id } = useParams();
  const country = getUserStoredCountry();
  const isLoading = useSelector(() => galleryList.isLoading());
  const [savingInProgress, setSavingInProgress] = useState(false);
  const gallery = useSelector(() => galleryList.getObject(gallery_id));
  const photographerPrice = useSelector(() =>
    photographerPriceList.getLoggedInPhotographerPrice(),
  );
  const isSaving = useSelector(
    () => galleryList.getIsSavingObject() || photographList.getIsSavingObject(),
  );

  const [galleryType, setGalleryType] = useState("");
  const [openSports, setOpenSports] = useState(false);
  const [activityTags, setActivityTags] = useState([]);
  const [galleryEvent, setgalleryEvent] = useState([]);
  const [genreTag, setGenreTag] = useState(null);
  const [sessionNameVal, setSessionNameVal] = useState("");
  const [descriptionVal, setDescriptionVal] = useState("");
  const [eventGallery, setEventGallery] = useState(null);
  const [openGalleryEvent, setOpenGalleryEvent] = useState(false);
  const [fileUploadsInProgress, setFileUploadsInProgress] = useState({});
  const [openGalleryGenreTagDropdown, setOpenGalleryGenreTagDropdown] =
    useState(false);

  const genreTagOptions = useSelector(() =>
    genreTagDropdownOptions.getAsOptions(),
  );
  const galleryEventOptions = useSelector(() =>
    galleryEventDropdownOptions.getAsOptions(),
  );

  const numFilesSelectedForUpload = size(fileUploadsInProgress);

  const numFilesCompleted = size(
    filter(
      fileUploadsInProgress,
      (f) =>
        f.status === "success" ||
        f.status == "failed" ||
        f.status == "duplicate",
    ),
  );
  const activityTagOptions = useSelector(() =>
    activityTagDropdownOptions.getAsOptionsWithEmptyOption({
      empty_label: "activity",
    }),
  );
  let activity_tag_options = activityTagOptions.filter(
    (val) => val.value !== "any",
  );

  const defaultValues = {
    shot_at_date: new Date(),
    shot_at_time: moment(new Date()).set({ hour: 14, minute: 0 }).toDate(),
    lat: null,
    lng: null,
    time_duration_hours: "2",
    session_name: null,
    description: gallery.description || "",
    activityTags: [],
    genre_tags: null,
    gallery_event: null,
    gallery_type: gallery.gallery_type || "photos",
    gallery_password: null,
    gallery_price: {
      currency_code: country.currency_code,
      country_code: country.country_code,
      base_price: null,
      low_res_price: null,
      discount1_percentage: null,
      discount2_percentage: null,
      discount3_percentage: null,
      discount4_percentage: null,
    },
  };

  const formProps = useForm({
    resolver: yupResolver(formSchema),
    defaultValues: defaultValues,
  });
  const {
    handleSubmit,
    control,
    clearErrors,
    reset,
    getValues,
    setValue,
    formState: { errors },
  } = formProps;

  const handleActivityTagChange = (event) => {
    setActivityTags(event.target.value);
  };

  const handleGalleryTypeChange = (event) => {
    setGalleryType(event.target.value);
    setValue("gallery_type", event.target.value);
  };

  const handleDescriptionTagsChange = (items) => {
    setValue("description", items.join(", "));
  };

  useEffect(() => {
    if (gallery && gallery.gallery_type) {
      setGalleryType(gallery.gallery_type);
      setValue("gallery_type", gallery.gallery_type, { shouldValidate: true });
    }
  }, [gallery]);

  useEffect(() => {
    if (eventGallery) {
      setGalleryType("event");
      setValue("gallery_type", "event", { shouldValidate: true });
    } else {
      setValue("gallery_event", "");
    }
  }, [eventGallery]);

  useEffect(() => {
    if (activityTags && openSports === true) {
      setOpenSports(false);
    }
  }, [activityTags]);

  const handleTagsChange = (items) => {
    setValue("tags", items.join(", "));
  };

  useEffect(() => {
    if (gallery.activity_tags) {
      if (activity_tag_options.length > 0) {
        let old_activity_tags = [];
        gallery.activity_tags.map((activity_tag) => {
          let obj = activity_tag_options.filter(
            (activity_tag_option) => activity_tag_option.value === activity_tag,
          );
          if (obj) {
            old_activity_tags.push(obj[0].original_item);
          } else {
            return;
          }
        });
        if (JSON.stringify(activityTags) != JSON.stringify(old_activity_tags)) {
          setActivityTags(old_activity_tags);
        }
      }
    }
  }, [gallery.activity_tags, activity_tag_options, gallery]);
  useEffect(() => {
    dispatch(photographerPriceList.ensurePhotographerPriceLoaded());
    dispatch(activityTagDropdownOptions.fetchListIfNeeded());
    dispatch(galleryEventDropdownOptions.fetchListIfNeeded());
    dispatch(genreTagDropdownOptions.fetchListIfNeeded());
  }, []);

  useEffect(() => {
    dispatch(galleryList.ensureObjectLoaded(gallery_id));
    dispatch(activityTagDropdownOptions.fetchListIfNeeded());
    dispatch(galleryEventDropdownOptions.fetchListIfNeeded());
    dispatch(genreTagDropdownOptions.fetchListIfNeeded());
  }, [gallery_id]);

  useEffect(() => {
    if (gallery.activity_tags) {
      if (activity_tag_options.length > 0) {
        let old_activity_tags = [];
        gallery.activity_tags.map((activity_tag) => {
          let obj = activity_tag_options.filter(
            (activity_tag_option) => activity_tag_option.value === activity_tag,
          );
          if (obj) {
            old_activity_tags.push(obj[0].original_item);
          } else {
            return;
          }
        });
        if (JSON.stringify(activityTags) != JSON.stringify(old_activity_tags)) {
          setActivityTags(old_activity_tags);
        }
      }
    }
  }, [gallery.activity_tags, activity_tag_options, gallery]);

  useEffect(() => {
    if (gallery_id) {
      return;
    }
    if (!get(photographerPrice, "id")) {
      return;
    }
    const values = Object.assign({}, defaultValues);
    values.gallery_price = clone(photographerPrice);
    reset(values);
  }, [get(photographerPrice, "id")]);

  useEffect(() => {
    if (!gallery.id) {
      return;
    }
    const values = Object.assign({}, defaultValues, gallery);
    if (!values.gallery_price) {
      values.gallery_price = clone(defaultValues.gallery_price);
    }
    const m = moment.utc(values.shot_at_datetime);
    values.shot_at_date = new Date(m.year(), m.month(), m.date(), m.hour(), m.minute());
    values.shot_at_time = new Date(m.year(), m.month(), m.date(), m.hour(), m.minute());
    reset(values);
  }, [gallery.id]);

  const onSave = (values) => {
    values = {
      ...values,
      activity_tags: activityTags.map((val) => val.id),
      sport_tag_deprecated: null,
    };
    clearErrors();

    const on_file_upload_progress = function (file, status) {
      let progress = fileUploadsInProgress;
      progress[file.path] = { status: status };
      setFileUploadsInProgress({ ...progress });
    };

    const on_all_saved = function (
      gallery_id,
      { successes, failures, reason },
    ) {
      let path;
      if (size(failures) > 0 && size(successes) == 0) {
        path = `/photographer/gallery/${gallery_id}`;
        if (reason === "unacceptedfilesize") {
          showError(
            "Failed",
            "Photos must be greater than 20kb and less than 5Mb",
          );
        } else {
          showError("Failed", "Failed to save any photos");
        }
      } else if (size(failures) > 0) {
        path = `/photographer/gallery/${gallery_id}`;
        showError(
          "Partial Failure",
          `${size(failures)} photos failed to save, ${size(successes)} saved`,
        );
      } else {
        showSuccess("Success", `${size(successes)} photos saved`);
        path = `/photographer/map`;
      }
      if (galleryType === "photo_art") {
        history.push("/photographer/photo_art_gallery");
      } else {
        history.push(path);
      }
      dispatch(galleryList.invalidateList());
    };
    const on_gallery_save_ok = function (json) {
      const gallery = json;
      const gallery_id = gallery.id;
      const gallery_type_value = getValues("gallery_type");
      dispatch(galleryList.invalidateList());

      const photos = get(values, "files");
      let path;
      if (size(photos) === 0 && gallery_type_value !== "photo_art") {
        history.push(`/photographer/map`);
        if (gallery_id) {
          showSuccess("Success", "Gallery updated with no new photos");
        } else {
          showSuccess("Success", "Empty gallery created");
        }
      }
      if (size(photos) === 0 && gallery_type_value === "photo_art") {
        history.push("/photographer/photo_art_gallery");
        if (gallery_id) {
          showSuccess("Success", "Photo art updated with no new photos");
        } else {
          showSuccess("Success", "No photo created");
        }
      } else {
        galleryList
          .savePhotos({
            files: photos,
            gallery: gallery,
            gallery_id: gallery_id,
            country_code: country.country_code,
            on_file_upload_progress,
          })
          .then((res) =>
            handleSubmitResult({
              res,
              formProps,
              on_ok: (res) => on_all_saved(gallery_id, res),
            }),
          );
      }
    };

    const d = values.shot_at_date;
    const t = values.shot_at_time;
    values.shot_at_datetime = moment.utc([
      d.getFullYear(), d.getMonth(), d.getDate(),
      t.getHours(), t.getMinutes(), 0
    ]).format();

    values.gallery_name = createGalleryName(values);

    if (gallery_id) {
      values.id = gallery_id;
      return dispatch(galleryList.saveObject(values)).then((res) =>
        handleSubmitResult({ res, formProps, on_ok: on_gallery_save_ok }),
      );
    } else {
      return dispatch(galleryList.saveNewObject(values)).then((res) =>
        handleSubmitResult({ res, formProps, on_ok: on_gallery_save_ok }),
      );
    }
  };

  const onCancel = () => {
    if (gallery_id && galleryType !== "photo_art") {
      history.push(`/photographer/map`);
    } else if (gallery_id && galleryType === "photo_art") {
      history.push("/photographer/photo_art_gallery");
    } else {
      history.push(`/photographer/map`);
    }
  };

  const createGalleryName = (values) => {
    let gallery_name;
    const user_last_name = loggedInUserLastName();
    const date = moment.utc(values.shot_at_datetime).format("MMM Do");
    const first_time = moment.utc(values.shot_at_datetime).format("HH:mm");
    const second_time = moment.utc(values.shot_at_datetime)
      .add(values.time_duration_hours, "hours")
      .format("HH:mm");
    const tag_Name = activityTags.map((tag) => ` ${tag.name}`).toString();
    if (galleryType !== "photo_art") {
      gallery_name = `${date}.${first_time}-${second_time}, ${values.session_name},${tag_Name}, ${user_last_name}`;
    } else {
      gallery_name = `${values.session_name},
                          ${tag_Name ? tag_Name + "," : " "}
                          ${user_last_name}`;
    }
    return gallery_name;
  };

  const renderUploadInProgress = () => {
    return (
      <div className={classes.saving}>
        {numFilesSelectedForUpload === 0 && <LoadingSpinner />}
        <div className={classes.progressWrapper}>
          <LoaderPercentProgressContainer />
        </div>
      </div>
    );
  };

  const renderExistingGalleryHeader = () => {
    return (
      <Box display="flex" alignItems="center" paddingLeft="32px">
        <Typography
          className={classes.editGalleryTypography}
          style={{ textAlign: "center" }}
        >
          <font className={classes.loadGalleryTitle}>Edit Gallery Details</font>
        </Typography>
      </Box>
    );
  };

  const renderNewGalleryHeader = () => {
    return (
      <Box display="flex" alignItems="center" paddingLeft="32px">
        <Typography
          className={classes.titletypography}
          style={{ textAlign: "center" }}
        >
          <font className={classes.loadGalleryTitle}>
            Load up a New Gallery
          </font>
        </Typography>
      </Box>
    );
  };

  const renderGalleryType = () => {
    return (
      <>
        <Typography
          className={`${classes.typographyMain} ${classes.GalleryTypeRadioGroup}`}
        >
          <Controller
            name="gallery_type"
            control={control}
            render={(fieldProps) => (
              <RadioGroup
                fieldProps={fieldProps}
                row
                name="gallery_type"
                value={fieldProps.field.value}
                onChange={handleGalleryTypeChange}
              >
                <FormControlLabel
                  value="photos"
                  control={<Radio />}
                  label="Pictures of Individuals"
                />
                <FormControlLabel
                  value="photo_art"
                  control={<Radio />}
                  label="Photo Art"
                />
                <FormControlLabel
                  value="event"
                  control={<Radio />}
                  label="Event/School/Organization"
                />
              </RadioGroup>
            )}
          />
        </Typography>
      </>
    );
  };

  const renderDateAndTimeOfShootFields = () => {
    return (
      <>
        <Typography className={classes.typography}>Date of Shoot</Typography>
        <Controller
          name="shot_at_date"
          control={control}
          render={(fieldProps) => (
            <span classname={classes.placeHolderSize}>
              <DatePicker fieldProps={fieldProps} autoOk classes={classes} />
            </span>
          )}
        />
        <Typography className={classes.typography}>Time of Shoot</Typography>
        <Controller
          name="shot_at_time"
          control={control}
          label="Start time of shoot"
          render={(fieldProps) => (
            <span classname={classes.placeHolderSize}>
              <TimePicker fieldProps={fieldProps} autoOk classes={classes} />
            </span>
          )}
        />
      </>
    );
  };

  const renderEventField = () => {
    return (
      <>
        <Typography className={`${classes.typography}`}>
          Event/School/Organization
        </Typography>
        <Controller
          name="gallery_event"
          control={control}
          render={(fieldProps, onEventValChanged) => (
            <TextField
              fieldProps={fieldProps}
              className={classes.textField}
              select
              onEventValChanged={setEventGallery(fieldProps.field.value)}
            >
              <MenuItem value={null}>
                <span className={classes.drop}>{"No Event"}</span>
              </MenuItem>
              {map(galleryEventOptions, (v, index) => (
                <MenuItem value={v.value} key={index}>
                  <span className={classes.drop}>{v.label}</span>
                </MenuItem>
              ))}
            </TextField>
          )}
        />
      </>
    );
  };

  const renderGalleryGenreField = () => {
    return (
      <>
        <Typography className={`${classes.typography}`}>Genre</Typography>
        <Controller
          name="genre_tags"
          control={control}
          render={(fieldProps, onGenreTagValChanged) => (
            <TextField
              fieldProps={fieldProps}
              className={classes.textField}
              select
              onGenreTagValChanged={setGenreTag(fieldProps.field.value)}
            >
              <MenuItem value={null}>
                <span className={classes.drop}>{"No Genre"}</span>
              </MenuItem>
              {map(genreTagOptions, (v, index) => (
                <MenuItem value={v.value} key={index}>
                  <span className={classes.drop}>{v.label}</span>
                </MenuItem>
              ))}
            </TextField>
          )}
        />
      </>
    );
  };

  const renderPhotoSessionNameField = () => {
    return (
      <>
        <Typography className={classes.typography}>
          {galleryType === "photo_art" ? "Photo Name" : "Session Name/Place:"}
        </Typography>
        <Controller
          name="session_name"
          control={control}
          render={(fieldProps, onSessionNameValChanged) => (
            <TextField
              fieldProps={fieldProps}
              type="text"
              variant="standard"
              placeholder="eg Sunset at Bondi Beach"
              className={classes.textField}
              onSessionValChanged={setSessionNameVal(fieldProps.field.value)}
            />
          )}
        />
      </>
    );
  };

  const renderActivityField = () => {
    return (
      <>
        <Typography className={classes.typography}>Sport/Activity:</Typography>

        <Controller
          name="activity_tags"
          control={control}
          render={(fieldProps) => (
            <Select
              className={classes.textField}
              labelId="activity_tags"
              displayEmpty
              fieldProps={fieldProps}
              id="activity_tags"
              multiple
              open={openSports}
              onClick={() => setOpenSports(true)}
              value={activityTags}
              onChange={handleActivityTagChange}
              input={<Input id="activity_tags" />}
              renderValue={(selected) => {
                if (selected.length === 0) {
                  return (
                    <span className={classes.grayDrop}>
                      eg Surfing, Hockey etc
                    </span>
                  );
                }
                return (
                  <div className={classes.chips}>
                    {selected.map((value) => (
                      <>
                        <Chip
                          key={value.id}
                          label={value.name}
                          className={classes.chip}
                        />
                      </>
                    ))}
                  </div>
                );
              }}
              MenuProps={MenuClass}
            >
              {activity_tag_options
                .sort((a, b) =>
                  a.label.toLowerCase() > b.label.toLowerCase() ? 1 : -1,
                )
                .map((activity_tag_option) => (
                  <MenuItem
                    key={activity_tag_option.value}
                    value={activity_tag_option.original_item}
                  >
                    <Checkbox
                      checked={activityTags.includes(
                        activity_tag_option.original_item,
                      )}
                      name="checkedB"
                      color="primary"
                    />
                    {activity_tag_option.label}
                  </MenuItem>
                ))}
            </Select>
          )}
        />
      </>
    );
  };

  const renderDescriptionField = () => {
    return (
      <>
        <Typography className={classes.typography}>Tags</Typography>
        <Controller
          name="description"
          control={control}
          render={(fieldProps) => (
            <TextField
              fieldProps={fieldProps}
              type="text"
              variant="standard"
              placeholder="eg Woman surfer, Happy etc"
              className={classes.textField}
              onDescriptionValChanged={setDescriptionVal(
                fieldProps.field.value,
              )}
            />
          )}
        />
        <FormHelperText id="filled-weight-helper-text">
          Comma seperated
        </FormHelperText>
      </>
    );
  };

  const renderGalleryPassword = () => {
    return (
      <>
        <Typography className={`${classes.typography}`}>Password:</Typography>
        <Controller
          name="gallery_password"
          control={control}
          render={(fieldProps) => (
            <TextField
              fieldProps={fieldProps}
              type="password"
              autoComplete="new-password"
              variant="standard"
              placeholder="Only Enter if Applicable"
              className={classes.textField}
            />
          )}
        />
      </>
    );
  };

  const renderLeftInputFields = () => {
    return (
      <>
        {renderGalleryType()}
        {galleryType !== "photo_art" && (
          <>
            {renderDateAndTimeOfShootFields()}
            {renderEventField()}
          </>
        )}
        {galleryType === "photo_art" && (
          <>
            {renderPhotoSessionNameField()}
            {renderActivityField()}
          </>
        )}
      </>
    );
  };

  const renderRightInputFields = () => {
    return (
      <>
        {galleryType !== "photo_art" && (
          <>
            {renderPhotoSessionNameField()}
            {renderActivityField()}
            {renderGalleryPassword()}
          </>
        )}
        {galleryType === "photo_art" && (
          <>
            {renderGalleryGenreField()}
            {renderDescriptionField()}
          </>
        )}
      </>
    );
  };

  const renderUploadProgress = () => {
    if (numFilesSelectedForUpload === 0) {
      return null;
    }

    return (
      <div>
        {/* <LoadingSpinner /> */}
        {numFilesCompleted} of {numFilesSelectedForUpload} completed.
      </div>
    );
  };

  const renderPhotoUploader = () => {
    return (
      <PhotographUploader
        onChange={({ files }) =>
          setValue("files", files, { shouldValidate: true })
        }
        fileAnnotations={fileUploadsInProgress}
        maxFileLimit={getValues("gallery_type") === "photo_art" ? 1 : null}
      />
    );
  };

  const renderLocationSelector = () => {
    return <LocationSelector formProps={formProps} />;
  };

  const renderPriceSelector = () => {
    return (
      <GalleryPriceSelector
        formProps={formProps}
        gallery_id={gallery_id}
        gallery={gallery}
        gallery_type={galleryType}
        field_name_prefix="gallery_price"
      />
    );
  };

  const okToSubmit =
    getValues("session_name") &&
    getValues("lat") &&
    getValues("gallery_price.base_price") &&
    getValues("files");

  const okToSubmitPhotoArt =
    getValues("session_name") &&
    getValues("description") &&
    getValues("genre_tags") &&
    getValues("gallery_price.base_price") &&
    getValues("files");

  const renderSubmitPhotoBtn = () => {
    return (
      <>
        {!okToSubmit && (
          <Button disabled className={classes.largeGrayBtn} type="submit">
            Submit Photo/s
          </Button>
        )}
        {okToSubmit && getValues("gallery_type") !== "photo_art" && (
          <Button className={classes.largeBlueBtn} type="submit">
            Submit Photo/s
          </Button>
        )}
        {okToSubmitPhotoArt && getValues("gallery_type") === "photo_art" && (
          <Button className={classes.largeBlueBtn} type="submit">
            Submit Photo
          </Button>
        )}
      </>
    );
  };

  const renderSubmitButton = () => {
    return (
      <div className={classes.submitAndCancelBtn}>
        {gallery_id ? (
          <Button className={classes.largeBlueBtn} type="submit" disabled>
            Update and Submit
          </Button>
        ) : (
          renderSubmitPhotoBtn()
        )}
        <Button className={classes.largeGrayBtn} onClick={onCancel}>
          Cancel
        </Button>
      </div>
    );
  };

  const renderForm = () => {
    return (
      <div className={classes.gallery_editor_container}>
        <form onSubmit={handleSubmit(onSave)}>
          <GeneralFormErrors formProps={formProps} />
          <Grid container>
            <Grid item xs={5} className={`${classes.grid} ${classes.grid1}`}>
              {renderLeftInputFields()}
            </Grid>
            <Grid item xs={5} className={classes.grid}>
              <Separator height={63} />
              {renderRightInputFields()}
            </Grid>
            <Grid item xs={12} className={classes.grid2}>
              <Separator height={20} />
              {renderLocationSelector()}
              <Separator height={20} />
              {renderPriceSelector()}
              <Separator height={20} />
              {renderUploadProgress()}
              {renderPhotoUploader()}
              <Separator height={20} />
              {renderSubmitButton()}
            </Grid>
          </Grid>
        </form>
      </div>
    );
  };

  return (
    <div className={classes.galleryEditorPage}>
      {renderForm()}
      {!gallery_id && renderNewGalleryHeader()}
      {isSaving && numFilesSelectedForUpload === 0 && renderUploadInProgress()}
    </div>
  );
};
